import React from 'react';
import {View, Text, Platform} from 'react-native';

import {tID} from '../../../utils/TestIdHelper';
import {useTheme, useThemedStyles} from '../../../theme';
import IconButton from '../IconButton';

import makeStyles from './styles';
import {LeftArrowIcon} from '../../../utils/SvgIcons';

export default function Header({
  leftImage = <LeftArrowIcon />,
  title = '',
  onPressLeftIcon,
  hideLeftIem = false,
  // VoiceOver/TalkBack name for the left icon; screens using a close icon
  // should pass 'Close'.
  leftIconAccessibilityLabel = 'Back',
}) {
  const {colors} = useTheme();
  const styles = useThemedStyles(makeStyles);
  return (
    <View testID={tID('Header-View-Container')} style={styles.container}>
      {Platform.OS === 'web' ? (
        <>
          <View
            testID={tID('Header-View-LeftContainer')}
            style={styles.leftContainer}
          >
            <Text
              testID={tID('Header-Text-Title')}
              style={styles.titleStyle}
              maxFontSizeMultiplier={1.3}
              numberOfLines={1}
              adjustsFontSizeToFit
            >
              {title}
            </Text>
          </View>
          {!hideLeftIem && (
            <IconButton
              onPress={onPressLeftIcon}
              imageSize={16}
              leftImage={leftImage}
              tintColor={colors.textPrimary}
              accessibilityLabel={leftIconAccessibilityLabel}
            />
          )}
          {/* <View style={styles.rightContainer}></View> */}
        </>
      ) : (
        <>
          <View
            testID={tID('Header-View-LeftContainer')}
            style={styles.leftContainer}
          >
            {!hideLeftIem && (
              <IconButton
                onPress={onPressLeftIcon}
                imageSize={16}
                leftImage={leftImage}
                tintColor={colors.textPrimary}
                accessibilityLabel={leftIconAccessibilityLabel}
              />
            )}
          </View>
          <Text
            testID={tID('Header-Text-Title')}
            style={styles.titleStyle}
            maxFontSizeMultiplier={1.3}
            numberOfLines={1}
            adjustsFontSizeToFit
          >
            {title}
          </Text>
          <View
            testID={tID('Header-View-RightContainer')}
            style={styles.rightContainer}
           />
        </>
      )}
    </View>
  );
}
